<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      @open="modalOpen"
      :footer="false">
    <template #header>
      关键词<span class="modal-secondary-title">{{keyword.keyword | defaultShow('(', ')', '')}}</span>
    </template>
    <template #content>
      <div v-loading="loading"
           ref="chart"
           class="trend-chart"
      ></div>
      <gj-radio-group
          v-model="filter.dateType"
          :options="option.dateType"
          @input="$gjNoticeQuery"
      ></gj-radio-group>
      <gj-table
          ref="gjTable"
          name="keywordRankTrend"
          :index="false"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :offset-height="7"
          @sort-change="$gjSortChange">
        <template v-slot:header:natureRank>
          自然排名
          <div>(页码/页内排名)</div>
        </template>
        <template v-slot:header:adsRank>
          广告排名
          <div>(页码/页内排名)</div>
        </template>
        <template v-slot:natureRank="{row}">
          <template v-if="row.naturePageRank === 0">
            前三页无排名
          </template>
          <template v-else-if="row.naturePageRank > 0">
            {{row.naturePageNum}}/{{row.naturePageRank}}
          </template>
          <template v-else>
            -
          </template>
        </template>
        <template v-slot:adsRank="{row}">
          <template v-if="row.adsPageRank === 0">
            前三页无排名
          </template>
          <template v-else-if="row.adsPageRank">
            {{row.adsPageNum}}/{{row.adsPageRank}}
            <template v-if="row.trend === KeywordRankEnum.trend.UP">
              <gj-icon class="el-icon-top up-icon"></gj-icon>
            </template>
            <template v-else-if="row.trend === KeywordRankEnum.trend.DOWN">
              <gj-icon class="el-icon-bottom down-icon"></gj-icon>
            </template>
            <template v-else-if="row.trend === KeywordRankEnum.trend.NO">
              <gj-icon class="el-icon-right no-icon"></gj-icon>
            </template>
          </template>
          <template v-else>
            前三页无排名
          </template>
        </template>
        <template v-slot:adsPageRank="{row}">
          <div>广告页码：{{row.adsPageNum ? row.adsPageNum : '-'}}</div>
          <div>页码排名：{{row.adsPageRank ? row.adsPageRank : '-'}}</div>
        </template>
        <template v-slot:memo="{row}">
          <template v-if="$permission('keywordRank:edit')">
            <gj-edit-input
                :value="row.memo"
                :item="row"
                table-cell-edit
                :on-confirm="updateMemo"
                :pop-title="'备注'">
              <gj-tooltip
                  :text-line="2"
                  :content="row.memo">
                {{row.memo | defaultShow}}
              </gj-tooltip>
            </gj-edit-input>
          </template>
          <gj-text v-else width="100%">{{row.memo | defaultShow}}</gj-text>
        </template>
      </gj-table>
    </template>
  </gj-modal>
</template>

<script>
  import {KeywordRankEnum} from "modules/common/ad/rank/keyword-rank/enum";
  import {stateOptionBoolean} from "@/utils/options";
  import {modalMixIn, queryMixin, responseMixin} from "@/minxins";
  import {getAdsRankTrend, updateAdKeywordRankMemo} from "@/api/ad";
  import {defaultShow} from "@/filters";
  export default {
    name: "app-keyword-rank-trend-modal",
    mixins: [modalMixIn, responseMixin, queryMixin],
    props: {
      keyword: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'statisticsDate', header: '日期', field: 'statisticsDate', width: '120px'},
          {id: 'natureRank', header: 'slot:natureRank', field: 'slot:natureRank', width: '150px', align: 'center'},
          {id: 'adsRank', header: 'slot:adsRank', field: 'slot:adsRank', width: '150px', align: 'center'},
          {id: 'BS', header: 'B/S', field: 'option:bestSeller', options: () => stateOptionBoolean, help: '是否有Best Seller标记', width: '80px'},
          {id: 'AC', header: 'A/C', field: 'option:amazonsChoice', options: () => stateOptionBoolean, help: '是否有Amazons Choice标记', width: '80px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '200px'},
        ],
        chart: null,
        option: {
          dateType: [
            {id: "P1Y", text: "近1年"},
            {id: "P180D", text: "近180天"},
            {id: "P90D", text: "近90天"},
            {id: "P60D", text: "近60天"},
            {id: "P30D", text: "近30天"},
            {id: "P7D", text: "近7天"},
          ]
        },
        filter: {
          dateType: "P7D"
        },
        KeywordRankEnum: KeywordRankEnum,
        maxNum:0
      }
    },
    methods: {
      modalOpen() {
        this.$nextTick(() => this.renderChart());
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          keywordId: this.keyword.keywordId,
          dateType: this.filter.dateType,
        };
        // 查询
        this.loading = true;
        getAdsRankTrend(params)
          .then((data) => {
            this.tableData = data;
            this.chart.setOption({
              xAxis: {
                data: data.map(item => item.statisticsDate)
              },
              series: {
                // data: data.map(item => (item.adsRank || '-'))
                // data: data.map(item => (item.adsRank || (this.maxNum >= 10 ? (this.maxNum + 1) :10)))
                data: data.map(item => {
                  if(item.adsRank && item.adsRank<=150){
                    return item.adsRank
                  }else {
                    return 170
                  }
                })
              }
            });
          })
          .complete(() => this.loading = false);
      },
      updateMemo(memo, row, closeEditor, closeLoading) {
        updateAdKeywordRankMemo({
          id: row.id,
          memo,
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('更新备注成功');
              closeLoading();
              closeEditor();
              row.memo = memo;
            });
          })
          .complete(() => closeLoading());
      },
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          this.chart = this.$echarts.init(chartRef);
          const option = {
            color: ["rgb(0, 153, 255)"],
            tooltip: {
              trigger: 'axis',
              formatter: (e) => {
                const data = e[0];
                const point = `<div style="display: flex; justify-content: space-between"><div>排名</div><div>${data.data}</div></div>`;
                const noRank = `<div style="display: flex; justify-content: space-between"><div>无排名</div><div></div></div>`;
                if(data.data>150){
                  return `<div style="min-width: 100px; height: ">${data.name}<br/>${noRank}</div>`;
                }else {
                  return `<div style="min-width: 100px; height: ">${data.name}<br/>${point}</div>`;
                }

              },
              position: function(point, params, dom, rect, size) {
                if (point[0] + size.contentSize[0] + 30 > size.viewSize[0]) {
                  return [point[0] - size.contentSize[0] - 30, '15%'];
                }
                return [point[0] + 20, '15%'];
              },
            },
            legend: false,
            grid: {
              top: 10,
              left: '2%',
              right: '3%',
              bottom: 18,
              containLabel: true
            },
            xAxis: {
              position: 'top',
              inverse: true,
              axisLabel: {
                color: "#32393d"
              },
              axisLine: {
                lineStyle: {
                  color: "#32393d"
                }
              },
              boundaryGap: false,
              data: [],
            },
            yAxis: {
              position: "left",
              inverse: true,
              scale: true,
              min: 1,
              max: 170,
              // max: (value) => {
              //   if(value.max>=1){
              //     this.maxNum=value.max;
              //   }
              //   return value.max >= 10 ? value.max : 10;
              // },
              minInterval: 1,
              axisLabel: {
                margin: 4,
                formatter: (e) => {
                  let t = Math.abs(e);
                  if(t === 170){
                    return '无排名'
                  }else {
                    return t >= 1e4 && t < 1e7 ?
                        t = t / 1e4 + "万" :
                        t >= 1e7 && (t = t / 1e7 + "千万"), t;
                  }
                },
                color: "#32393d"
              },
              splitLine: {
                lineStyle: {
                  color: "#e5e9f2"
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#FFF"
                }
              }
            },
            series: [
              {
                data: [],
                type: 'line'
              }
            ]
          };
          this.chart.setOption(option);
          window.addEventListener("resize", () => {
            this.chart.resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .trend-chart {
    height: 220px;
  }
  .up-icon,
  .down-icon,
  .no-icon {
    font-weight: bold;
  }
  .up-icon {
    color: green;
  }
  .down-icon {
    color: red;
  }
  /deep/ .el-radio-group{
    margin-bottom: 16px;
  }
  /deep/ .gj-table .gj-help--icon .gj-icon{
     color: #999999;
  }
</style>
